let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hxKqs")).then(() => parcelRequire('iAmkR'));